import ModalWrapper from '../../common/Modal/ModalWrapper'
import Road from '../../dashboard/road'

const WhatYouGetModal = ({ subscription, Objective = "investment", company, showExpension, setShowExpension }) => {
    let data = {
        "investment": {
            "Free": [
                { card: 'investorMatch', description: 'Number of matches only' },
                { card: 'investorReadiness', description: 'Full report' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Report summaries only' }
            ],
            "Lite": [
                { card: 'investorMatch', description: 'Investor Names' },
                { card: 'investorReadiness', description: 'Full report' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Full report' },
                { card: 'diligencePack', description: 'Slim pack' }
            ],
            "Pro": [
                { card: 'investorFitReport', description: 'Detailed report on each investor' },
                { card: 'investorReadiness', description: 'Full report' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Full report + edit + build your own' },
                { card: 'diligencePack', description: 'Full pack + build your own' },
                { card: 'yourCertification', description: 'Stand out from the crowd' },
                { card: 'investorFitReport', description: '1-Click connections' }
            ]
        },
        "growth": {
            "Free": [
                { card: 'growthReadiness', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Report summaries only' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'loanReadiness', description: 'Full report' },
            ],
            "Lite": [
                { card: 'growthReadiness', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Report summaries only' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'diligencePack', description: 'Slim pack' },
                { card: 'loanReadiness', description: 'Full report' },
            ],
            "Pro": [
                { card: 'growthReadiness', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Report summaries only' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'diligencePack', description: 'Slim pack' },
                { card: 'reasearchAidBuilder', description: 'Full research reports created by you' },
                { card: 'anyListBuilder', description: 'Full checklist modules created by you' },
                { card: 'partnerModule', description: 'Let partners create more value' },
                { card: 'yourCertification', description: 'Stand out from the crowd' },
            ]
        },
        "exit": {
            "Free": [
                { card: 'exitReadiness', description: 'Full report' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Report summaries only' }
            ],
            "Lite": [
                { card: 'exitReadiness', description: 'Full report' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Full report' },
                { card: 'diligencePack', description: 'Slim pack' }
            ],
            "Pro": [
                { card: 'exitReadiness', description: 'Full report' },
                { card: 'kpiReport', description: 'Full report' },
                { card: 'reasearchAidReport', description: 'Full report + edit + build your own' },
                { card: 'diligencePack', description: 'Full pack + build your own' },
                { card: 'reasearchAidBuilder', description: 'Full research reports created by you' },
                { card: 'anyListBuilder', description: 'Full checklist modules created by you' },
                { card: 'partnerModule', description: 'Let partners create more value' },
                { card: 'yourCertification', description: 'Stand out from the crowd' },
            ]
        },
    }

    let filteredData = { ...data }

    if (subscription === 'Lite') {
        delete filteredData[Objective.toLowerCase()]['Free']
    } else if (subscription === 'Pro') {
        delete filteredData[Objective.toLowerCase()]['Free']
        delete filteredData[Objective.toLowerCase()]['Lite']
    }

    // if subscription is undefined/null/Free → show all (as-is)
    // so no change required in that case

    return (
        <ModalWrapper modalType='whatYouGetModal' modalCardClasses='maw1500px py3rem' customStyle={{ paddingLeft: '0rem', paddingRight: '0rem' }}>
            <div>
                <h2 className='c15 fs2rem mb2rem tac fw500'>What You Get</h2>
                <div className='px1rem'>
                    {Object.entries(filteredData[Objective.toLowerCase()]).map(([keyTitle, items], objIndex) => (
                        <div
                            className={`df fdc br20px py3rem px1-5rem mb3rem ${(keyTitle === "Lite") ? "w80" : (keyTitle === "Free") ? "w70" : "w100"}`}
                            key={`${objIndex}_whatYouGet`}
                            style={{ background: '#D4DBFC' }}
                        >
                            <div className={`whatYouGetModalWrapper ${["Lite", "Free"].includes(keyTitle) && "pr"}`}>
                                <Road keyTitle={keyTitle} showExpension={showExpension} setShowExpension={setShowExpension} upgradeToPro={["Free", "Lite"].includes(keyTitle)} company={company} />
                                <div className='df fdc  jcsb pa' style={{ width: keyTitle === "Free" ? "78%" : '80%', marginLeft: '10%' }}>
                                    <div className='df'>
                                        {items.map((item, index) => {
                                            let cardImage = null;
                                            if (keyTitle === "Free") {
                                                if (item.card === 'investorMatch')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorMatchFree.png`);
                                                else if (item.card === 'investorReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorReadiness.png`);
                                                else if (item.card === 'kpiReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/kpiReport.png`);
                                                else if (item.card === 'reasearchAidReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/researchAidReport.png`);
                                                else if (item.card === 'growthReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/growthReadiness.png`);
                                                else if (item.card === 'loanReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/loanReadiness.png`);
                                                else if (item.card === 'exitReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/exitReadiness.png`);

                                            } else if (keyTitle === "Lite") {
                                                if (item.card === 'investorMatch')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorMatchFree.png`);
                                                else if (item.card === 'investorReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorReadiness.png`);
                                                else if (item.card === 'kpiReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/kpiReport.png`);
                                                else if (item.card === 'reasearchAidReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/researchAidReport.png`);
                                                else if (item.card === 'diligencePack')
                                                    cardImage = require(`../../../../images/whatYouGetModal/diligencePackFree.png`);
                                                else if (item.card === 'growthReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/growthReadiness.png`);
                                                else if (item.card === 'loanReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/loanReadiness.png`);
                                                else if (item.card === 'exitReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/exitReadiness.png`);
                                            } else if (keyTitle === "Pro") {
                                                if (item.card === 'investorMatch')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorMatchPro.png`);
                                                else if (item.card === 'investorReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorReadiness.png`);
                                                else if (item.card === 'kpiReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/kpiReport.png`);
                                                else if (item.card === 'reasearchAidReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/researchAidReport.png`);
                                                else if (item.card === 'diligencePack')
                                                    cardImage = require(`../../../../images/whatYouGetModal/diligencePackPro.png`);
                                                else if (item.card === 'yourCertification')
                                                    cardImage = require(`../../../../images/whatYouGetModal/yourCertificateJourney.png`);
                                                else if (item.card === 'investorFitReport')
                                                    cardImage = require(`../../../../images/whatYouGetModal/investorFitReportPro.png`);
                                                else if (item.card === 'reasearchAidBuilder')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/researchAid.png`);
                                                else if (item.card === 'anyListBuilder')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/anylistBulder.png`);
                                                else if (item.card === 'partnerModule')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/partnerModule.png`);
                                                else if (item.card === 'growthReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/growthReadiness.png`);
                                                else if (item.card === 'loanReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/growth/loanReadiness.png`);
                                                else if (item.card === 'exitReadiness')
                                                    cardImage = require(`../../../../images/whatYouGetModal/exitReadiness.png`);
                                            }

                                            // Skip rendering if cardImage is null
                                            if (!cardImage) {
                                                return null;
                                            }

                                            // Convert cardImage to string for safe string operations
                                            const cardImageStr = String(cardImage);
                                            return (
                                                <div className='df fdc aic jcc' style={{ maxWidth: '110px' }} key={index}>
                                                    <div className='df aic jcc' style={{ height: '154px' }}>
                                                        <img
                                                            src={cardImage}
                                                            className={keyTitle === "Free" ? "ml2rem" : 'ml0-5rem '}
                                                            alt='cardImage'
                                                            style={{
                                                                width: cardImageStr.includes('diligencePackFree') ? '112px' : cardImageStr.includes('researchAidReport') ? '100px' : cardImageStr.includes('diligencePackPro') ? '110px' : (Objective === "growth" || Objective === "exit") && keyTitle === "Pro" ? '90px' : '100px',
                                                                height: cardImageStr.includes('diligencePackFree') ? '123px' : cardImageStr.includes('researchAidReport') ? '128px' : cardImageStr.includes('diligencePackPro') ? '123px' : 'auto',
                                                                objectFit: 'contain'
                                                            }}

                                                        />
                                                    </div>
                                                    <div className='df fdc aic jcfs' style={{ height: '44px' }}>
                                                        <p className={`c15 fs12px mt0-5rem ${keyTitle === "Free" ? "ml2rem" : 'ml1rem '} tac w100`}>
                                                            {item.description}
                                                        </p>
                                                        {item.description === "1-Click connections" && (
                                                            <img
                                                                style={{ width: '80px' }}
                                                                src={require(`../../../../images/whatYouGetModal/appStoreIcon.png`)}
                                                                alt='appStoreIcon'
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        })}

                                        {keyTitle !== "Free" && (
                                            <div className={`df fdc jcfs aifs ${keyTitle === "Lite" ? 'ml1rem' : 'ml1rem'}`}>
                                                {
                                                    keyTitle === "Pro" ? (
                                                        <img style={{ width: '60px', marginTop: '3rem' }} src={require(`../../../../images/dashboard/goldenHandshake.png`)} alt='locationPin' />
                                                    ) : (
                                                        <img style={{ width: '50px', marginTop: '3rem' }} src={require(`../../../../images/whatYouGetModal/locationPin.png`)} alt='locationPin' />
                                                    )
                                                }
                                                <div className='mt0-5rem'>
                                                    {
                                                        Objective === "exit" && keyTitle !== "Free" ? <>
                                                            <h3 className='c15 fs1rem'>Present to purchasers</h3>
                                                            <p className='c15 fs13px'>Confident that you are <br></br> exit ready</p>
                                                        </> : Objective === "growth" && keyTitle !== "Free" ? <> <h3 className='c15 fs1rem'>See your <br></br> value grow</h3></> : <>
                                                            <h3 className='c15 fs1rem'>Pitch for <br></br> Investment</h3>
                                                            <p className='c15 fs13px'>Confident that you are <br /> investment ready</p>
                                                        </>
                                                    }

                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <p className='tac w100 c15 fs12px'>* AppStore requires Pro subscription</p>
            </div>
        </ModalWrapper>
    )
}

export default WhatYouGetModal
